import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { useState } from 'react';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setFormStatus('success');
      form.reset();
      setTimeout(() => setFormStatus('idle'), 3000);
      return;
    }

    const email = formData.get('email') as string;
    if (!email || !email.includes('@')) {
      setFormError('请填写有效的邮箱地址');
      return;
    }

    const message = formData.get('message') as string;
    if (!message || message.trim().length < 10) {
      setFormError('爆料内容不能少于10个字');
      return;
    }

    setFormStatus('success');
    form.reset();
    setTimeout(() => setFormStatus('idle'), 4000);
  };

  return (
    <>
      <Navbar />
      <main>
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-16">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
              <div>
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-5">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                  <span className="text-xs font-medium text-primary-400 font-label tracking-wider uppercase">ABOUT US</span>
                </div>
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 font-heading leading-tight mb-5">
                  关于<span className="text-primary-500">51暗网</span>
                </h1>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
                  51暗网成立于2024年，是国内领先的网红主播塌房黑料追踪平台。我们致力于为吃瓜群众提供最新、最全、最真实的网红主播塌房黑料资讯。无论是直播带货翻车、主播私生活爆料，还是网红圈内幕揭秘，51暗网都在第一时间为你呈现。
                </p>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
                  我们的编辑团队由资深娱乐记者和调查记者组成，坚持"真实、客观、及时"的报道原则。每一篇报道都经过严格的核实流程，确保信息的准确性和可信度。
                </p>
                <div className="flex flex-wrap gap-8 text-center">
                  <div>
                    <p className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">5000+</p>
                    <p className="text-xs text-foreground-500 mt-1">累计报道</p>
                  </div>
                  <div>
                    <p className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">200万+</p>
                    <p className="text-xs text-foreground-500 mt-1">月活跃用户</p>
                  </div>
                  <div>
                    <p className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">98.7%</p>
                    <p className="text-xs text-foreground-500 mt-1">信息准确率</p>
                  </div>
                </div>
              </div>
              <div className="relative">
                <div className="rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20dark%20theme%20newsroom%20office%20with%20multiple%20monitors%20displaying%20red%20breaking%20news%20alerts%20journalists%20at%20work%20dramatic%20lighting%20cinematic%20professional%20atmosphere%20with%20dark%20and%20red%20accents&width=1200&height=800&seq=about-hero-office&orientation=landscape"
                    alt="51暗网编辑部"
                    className="w-full aspect-[3/2] object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="absolute -bottom-4 -left-4 p-4 rounded-xl bg-background-100 border border-background-200/30">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                      <i className="ri-shield-check-fill text-background-50 text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-800">真实报道保证</p>
                      <p className="text-xs text-foreground-500">每条信息均经核实</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-16 bg-background-100/50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
                我们的<span className="text-primary-500">核心价值</span>
              </h2>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                51暗网始终坚持专业、客观、及时的报道理念，为吃瓜群众带来最优质的资讯体验
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              <div className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/30">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/10 mb-4">
                  <i className="ri-speed-up-fill text-primary-500 text-lg"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-800 mb-2">极速追踪</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  7x24小时全天候监控各大平台，网红塌房第一时间为你推送，绝不错过任何一个大瓜。
                </p>
              </div>
              <div className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/30">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/10 mb-4">
                  <i className="ri-spy-fill text-primary-500 text-lg"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-800 mb-2">深度调查</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  专业调查记者团队深入挖掘，不只是表面吃瓜，更要为你还原事件背后的完整真相。
                </p>
              </div>
              <div className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/30">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/10 mb-4">
                  <i className="ri-shield-user-fill text-primary-500 text-lg"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-800 mb-2">隐私保护</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  严格保护爆料人隐私信息，采用多重加密技术确保投稿者身份不被泄露，让你安心爆料。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-16">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
                站友<span className="text-accent-500">口碑</span>
              </h2>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                来看看吃瓜群众们怎么评价51暗网
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {[
                {
                  name: '资深吃瓜人',
                  role: '站友 · 2年',
                  content: '吃瓜吃了这么多年，51暗网是我见过信息最全、更新最快的平台。每次有大瓜都是这里最先发，已经安利给身边所有朋友了！',
                },
                {
                  name: '娱乐圈老司机',
                  role: '站友 · 1年',
                  content: '内容质量真的高，不是那种随便编故事的营销号。每篇报道都有详细的证据和截图，看得明明白白，吃瓜吃得放心。',
                },
                {
                  name: '夜猫子吃瓜',
                  role: '站友 · 8个月',
                  content: '最爱深夜刷51暗网，更新速度太快了，有时候半夜都能看到新瓜！网站界面也很清爽，没有乱七八糟的广告弹窗。',
                },
                {
                  name: '理性八卦者',
                  role: '站友 · 1年半',
                  content: '我觉得51暗网最难得的是做到了理性和八卦的平衡。不盲目跟风，不恶意炒作，这种态度在吃瓜圈真的很少见。',
                },
                {
                  name: '直播行业从业者',
                  role: '站友 · 6个月',
                  content: '作为行业内部人士，可以说51暗网的很多报道确实有料。虽然不是所有爆料都100%准确，但至少比外面那些乱写的强太多了。',
                },
                {
                  name: '日常摸鱼选手',
                  role: '站友 · 3个月',
                  content: '上班摸鱼必备！每天刷新好几遍，比追剧还上瘾。希望51暗网越做越好，多多更新，吃瓜群众永远支持你！加油！',
                },
              ].map((review, idx) => (
                <div key={idx} className="p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/30">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    {review.content}
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-primary-500/20 flex items-center justify-center">
                      <span className="text-xs font-bold text-primary-400">{review.name[0]}</span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{review.name}</p>
                      <p className="text-xs text-foreground-500">{review.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-16 bg-background-100/50">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
                联系我们
              </h2>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                有爆料？有合作？有建议？欢迎通过以下方式联系我们
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-12">
              <div>
                <div className="flex flex-col gap-5">
                  <h3 className="text-base font-semibold text-foreground-800 font-label tracking-wide uppercase">
                    联系方式
                  </h3>
                  <div className="flex items-start gap-4 p-4 rounded-xl bg-background-100 border border-background-200/30">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                      <i className="ri-mail-line text-primary-500 text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">爆料投稿</p>
                      <p className="text-xs text-foreground-500 mt-0.5">hello@blw91.cn</p>
                      <p className="text-xs text-foreground-400 mt-1">严格保护爆料人隐私，欢迎匿名投稿</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 p-4 rounded-xl bg-background-100 border border-background-200/30">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                      <i className="ri-service-line text-primary-500 text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">商务合作</p>
                      <p className="text-xs text-foreground-500 mt-0.5">hello@blw91.cn</p>
                      <p className="text-xs text-foreground-400 mt-1">广告投放、品牌合作、资源互换</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 p-4 rounded-xl bg-background-100 border border-background-200/30">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                      <i className="ri-customer-service-line text-primary-500 text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">客服热线</p>
                      <p className="text-xs text-foreground-500 mt-0.5">400-888-5151</p>
                      <p className="text-xs text-foreground-400 mt-1">工作日 9:00 - 18:00</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/30">
                <h3 className="text-base font-semibold text-foreground-800 mb-4 font-label tracking-wide uppercase">
                  在线爆料
                </h3>
                <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <div>
                    <label htmlFor="about-name" className="block text-xs font-medium text-foreground-600 mb-1.5">
                      你的昵称 <span className="text-foreground-400">(选填)</span>
                    </label>
                    <input
                      id="about-name"
                      type="text"
                      name="name"
                      placeholder="匿名吃瓜群众"
                      className="w-full px-3 py-2.5 rounded-lg bg-background-200/50 border border-background-300/30 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500/40 transition-colors"
                    />
                  </div>
                  <div>
                    <label htmlFor="about-email" className="block text-xs font-medium text-foreground-600 mb-1.5">
                      联系邮箱 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="about-email"
                      type="email"
                      name="email"
                      required
                      placeholder="hello@blw91.cn"
                      className="w-full px-3 py-2.5 rounded-lg bg-background-200/50 border border-background-300/30 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500/40 transition-colors"
                    />
                  </div>
                  <div>
                    <label htmlFor="about-message" className="block text-xs font-medium text-foreground-600 mb-1.5">
                      爆料内容 <span className="text-primary-500">*</span>
                    </label>
                    <textarea
                      id="about-message"
                      name="message"
                      required
                      rows={5}
                      maxLength={500}
                      placeholder="请详细描述你了解的黑料信息..."
                      className="w-full px-3 py-2.5 rounded-lg bg-background-200/50 border border-background-300/30 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500/40 transition-colors resize-none"
                    ></textarea>
                    <p className="text-[10px] text-foreground-400 mt-1">最多500字</p>
                  </div>
                  {formError && (
                    <p className="text-xs text-primary-500">{formError}</p>
                  )}
                  {formStatus === 'success' && (
                    <p className="text-xs text-secondary-400">爆料已提交，感谢你的贡献！我们会尽快核实处理。</p>
                  )}
                  <button
                    type="submit"
                    className="whitespace-nowrap w-full py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer"
                  >
                    提交爆料
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-16">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
                常见问题
              </h2>
            </div>
            <div className="flex flex-col gap-4">
              {[
                {
                  q: '51暗网的信息来源可靠吗？',
                  a: '我们的编辑团队会对每一条爆料信息进行多方核实，包括联系当事人、查看原始截图视频、比对多个信息源等。虽然不能保证100%准确，但我们会尽可能确保报道的真实性和客观性。对于未经证实的信息，我们会在文中明确标注。',
                },
                {
                  q: '如何向51暗网投稿爆料？',
                  a: '你可以通过本页的在线爆料表单提交信息，也可以发送邮件至 hello@blw91.cn。我们严格保护爆料人的隐私信息，支持匿名投稿。请尽可能提供详细的证据材料（截图、录屏、聊天记录等），这将有助于我们更快核实。',
                },
                {
                  q: '51暗网会收费吗？',
                  a: '51暗网目前完全免费，所有吃瓜内容均可免费阅读。我们没有付费墙，也不会向用户收取任何费用。网站的运营主要依靠广告和品牌合作。',
                },
                {
                  q: '如果发现报道信息有误怎么办？',
                  a: '如果你认为我们的报道存在事实错误，请通过客服邮箱 hello@blw91.cn 联系我们，并提供相关证据。我们会在核实后第一时间进行更正或撤稿，并发布更正声明。',
                },
              ].map((faq, idx) => (
                <details key={idx} className="group p-5 rounded-xl bg-background-100 border border-background-200/30 cursor-pointer">
                  <summary className="flex items-center justify-between text-sm font-medium text-foreground-800 list-none">
                    <span>{faq.q}</span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                    {faq.a}
                  </p>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "关于51暗网",
          "url": "http://blw91.cn/about",
          "description": "51暗网是国内领先的网红主播塌房黑料追踪平台，致力于为吃瓜群众提供最新最全的网红塌房资讯。",
          "isPartOf": {
            "@type": "WebSite",
            "name": "51暗网",
            "url": "http://blw91.cn/"
          },
          "inLanguage": "zh-CN"
        })
      }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "51暗网的信息来源可靠吗？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "我们的编辑团队会对每一条爆料信息进行多方核实，包括联系当事人、查看原始截图视频、比对多个信息源等。虽然不能保证100%准确，但我们会尽可能确保报道的真实性和客观性。对于未经证实的信息，我们会在文中明确标注。"
              }
            },
            {
              "@type": "Question",
              "name": "如何向51暗网投稿爆料？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "你可以通过本页的在线爆料表单提交信息，也可以发送邮件至 hello@blw91.cn。我们严格保护爆料人的隐私信息，支持匿名投稿。"
              }
            },
            {
              "@type": "Question",
              "name": "51暗网会收费吗？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "51暗网目前完全免费，所有吃瓜内容均可免费阅读。我们没有付费墙，也不会向用户收取任何费用。"
              }
            },
            {
              "@type": "Question",
              "name": "如果发现报道信息有误怎么办？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "如果你认为我们的报道存在事实错误，请通过客服邮箱联系我们，并提供相关证据。我们会在核实后第一时间进行更正或撤稿。"
              }
            }
          ]
        })
      }} />
    </>
  );
}